import { createActionsHook } from "react-redux-actions-hook";
import { WaterUserActionType } from "./constants";
import {
  ALL_CITIES_URL,
  CITY_METRICS_URL,
  ALL_TRIBES_URL,
  TRIBES_METRICS_URL,
  GET_SHORTAGE_BY_TRIBE,
  GET_SHORTAGE_BY_CATEGORY,
  ALL_AGRICULTURE_URL,
  AGRICULTURE_METRICS_URL,
  GET_ALL_DISTRICT_WATER,
  GET_ALL_DELIVERIES,
  ENTITY_ENTITLMENTS_URL,
  GET_INDUSTRY_METRICS,
  ALL_CITIES_WATER_USE,
} from "api/constants";
import { api } from "api/common";
import { setToastMessage } from "components/app/actions";

export const toggleAboutDrawer = () => {
  return { type: WaterUserActionType.TOGGLE_ABOUT };
};

export const setScenario = (scenario) => {
  return { type: WaterUserActionType.SET_SCENARIO, scenario };
};

export const setWaterUserChart = (chart_index) => {
  return { type: WaterUserActionType.SET_CHART, chart_index };
};

export const resetWaterUserChart = () => {
  return { type: WaterUserActionType.RESET_CHART };
};

// CITIES

export const resetSelectedCity = () => {
  return { type: WaterUserActionType.RESET_SELECTED_CITY };
};
export const listCities = (cities) => {
  return { type: WaterUserActionType.SET_ALL_CITIES, cities };
};
export const loadCities = () => {
  return (dispatch) => {
    api(`${ALL_CITIES_URL}`, { method: "GET" }, dispatch)
      .then((response) => {
        dispatch(listCities(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch topics",
            type: "error",
          })
        );
      });
  };
};

export const listCityAvailableWater = (city_water_data) => {
  return {
    type: WaterUserActionType.SET_CITY_WATER_AVAILABILITY,
    city_water_data,
  };
};

export const loadCityAvailableWater = (entity_name, scenario) => {
  return (dispatch) => {
    api(
      `${ENTITY_ENTITLMENTS_URL}`,
      {
        method: "POST",
        body: JSON.stringify({ entity: entity_name, scenario }),
      },
      dispatch
    )
      .then((response) => {
        dispatch(listCityAvailableWater(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch topics",
            type: "error",
          })
        );
      });
  };
};

export const listCityMetrics = (city_metrics) => {
  return { type: WaterUserActionType.SET_CITY_METRICS, city_metrics };
};

export const loadCityMetrics = (city_id) => {
  return (dispatch) => {
    api(
      `${CITY_METRICS_URL}`,
      { method: "POST", body: JSON.stringify({ city_id }) },
      dispatch
    )
      .then((response) => {
        dispatch(listCityMetrics(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch topics",
            type: "error",
          })
        );
      });
  };
};

export const loadAllCitiesWaterUse = () => {
  return (dispatch) => {
    api(`${ALL_CITIES_WATER_USE}`, { method: "GET" }, dispatch)
      .then((response) => {
        dispatch(listAllCitiesWaterUse(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch topics",
            type: "error",
          })
        );
      });
  };
};

export const listAllCitiesWaterUse = (all_cities_water_use) => {
  return {
    type: WaterUserActionType.SET_ALL_CITIES_WATER_USE,
    all_cities_water_use,
  };
};

export const setSelectedCity = (city_selected) => {
  return { type: WaterUserActionType.SET_SELECTED_CITY, city_selected };
};

// TRIBES

export const resetSelectedTribe = () => {
  return { type: WaterUserActionType.RESET_SELECTED_TRIBE };
};
export const listTribes = (tribes) => {
  return { type: WaterUserActionType.SET_ALL_TRIBES, tribes };
};
export const loadTribes = () => {
  return (dispatch) => {
    api(`${ALL_TRIBES_URL}`, { method: "GET" }, dispatch)
      .then((response) => {
        response.data.rows.forEach((ele) => {
          ele.label = ele.label.replace("Reservation", "Indian Community");
          // console.log(ele);
        });
        // console.log(response.data.rows);
        dispatch(listTribes(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch topics",
            type: "error",
          })
        );
      });
  };
};

export const setSelectedTribe = (tribe_selected) => {
  return { type: WaterUserActionType.SET_SELECTED_TRIBE, tribe_selected };
};

export const loadTribalShortages = (scenario_id, tribe_id) => {
  return (dispatch) => {
    api(
      `${GET_SHORTAGE_BY_TRIBE}`,
      { method: "POST", body: JSON.stringify({ scenario_id, tribe_id }) },
      dispatch
    )
      .then((response) => {
        dispatch(listTribalShortage(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch tribal shortages",
            type: "error",
          })
        );
      });
  };
};

export const listTribalShortage = (tribal_shortage) => {
  return { type: WaterUserActionType.SET_TRIBAL_SHORTAGES, tribal_shortage };
};

export const listTribeMetrics = (tribe_metrics) => {
  return { type: WaterUserActionType.SET_TRIBE_METRICS, tribe_metrics };
};

export const loadTribeMetrics = (tribe_id) => {
  return (dispatch) => {
    api(
      `${TRIBES_METRICS_URL}`,
      { method: "POST", body: JSON.stringify({ tribe_id }) },
      dispatch
    )
      .then((response) => {
        dispatch(listTribeMetrics(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch tribe metrics",
            type: "error",
          })
        );
      });
  };
};

// INDUSTRY

export const setSelectedIndustry = (industry_selected) => {
  return { type: WaterUserActionType.SET_SELECTED_INDUSTRY, industry_selected };
};
export const loadIndustryShortages = (category) => {
  return (dispatch) => {
    api(
      `${GET_SHORTAGE_BY_CATEGORY}`,
      { method: "POST", body: JSON.stringify({ category }) },
      dispatch
    )
      .then((response) => {
        dispatch(listIndustryShortage(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch topics",
            type: "error",
          })
        );
      });
  };
};

export const listIndustryShortage = (industry_shortage) => {
  return {
    type: WaterUserActionType.SET_INDUSTRY_SHORTAGES,
    industry_shortage,
  };
};

// AGRICULTURE
export const resetSelectedAgriculture = () => {
  return { type: WaterUserActionType.RESET_SELECTED_AGRICULTURE };
};
export const listAgriculture = (agriculture) => {
  return { type: WaterUserActionType.SET_ALL_AGRICULTURE, agriculture };
};
export const loadAgriculture = () => {
  return (dispatch) => {
    api(`${ALL_AGRICULTURE_URL}`, { method: "GET" }, dispatch)
      .then((response) => {
        dispatch(listAgriculture(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch topics",
            type: "error",
          })
        );
      });
  };
};

export const listAgricultureMetrics = (agriculture_metrics) => {
  return {
    type: WaterUserActionType.SET_AGRICULTURE_METRICS,
    agriculture_metrics,
  };
};

export const loadAgricultureMetrics = (agriculture_id) => {
  return (dispatch) => {
    api(
      `${AGRICULTURE_METRICS_URL}`,
      { method: "POST", body: JSON.stringify({ agriculture_id }) },
      dispatch
    )
      .then((response) => {
        dispatch(listAgricultureMetrics(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch topics",
            type: "error",
          })
        );
      });
  };
};

export const setSelectedAgriculture = (agriculture_selected) => {
  return {
    type: WaterUserActionType.SET_SELECTED_AGRICULTURE,
    agriculture_selected,
  };
};

export const loadAgricultureDistrictWater = () => {
  return (dispatch) => {
    api(`${GET_ALL_DISTRICT_WATER}`, { method: "GET" }, dispatch)
      .then((response) => {
        dispatch(listAgricultureDistrictWater(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch topics",
            type: "error",
          })
        );
      });
  };
};

export const listAgricultureDistrictWater = (district_water) => {
  return {
    type: WaterUserActionType.SET_DISTRICT_WATER,
    district_water,
  };
};

export const setWaterUserOption = (water_user_options) => {
  return {
    type: WaterUserActionType.SET_WATER_USER_OPTIONS,
    water_user_options,
  };
};

export const setWaterUser = (water_user) => {
  return {
    type: WaterUserActionType.SET_WATER_USER,
    water_user,
  };
};

export const loadWaterDeliveries = () => {
  return (dispatch) => {
    api(`${GET_ALL_DELIVERIES}`, { method: "GET" }, dispatch)
      .then((response) => {
        dispatch(listWaterDeliveries(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch topics",
            type: "error",
          })
        );
      });
  };
};

export const listWaterDeliveries = (deliveries) => {
  return {
    type: WaterUserActionType.SET_DELIVERIES,
    deliveries,
  };
};

//INDUSTRY

export const resetSelectedIndustry = () => {
  return { type: WaterUserActionType.RESET_SELECTED_INDUSTRY };
};
export const loadIndustryMetrics = () => {
  return (dispatch) => {
    api(`${GET_INDUSTRY_METRICS}`, { method: "GET" }, dispatch)
      .then((response) => {
        dispatch(listIndustryMetrics(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch topics",
            type: "error",
          })
        );
      });
  };
};

export const listIndustryMetrics = (industry_metrics) => {
  return {
    type: WaterUserActionType.SET_INDUSTRY_METRICS,
    industry_metrics,
  };
};

export default createActionsHook({
  toggleAboutDrawer,
  setWaterUserChart,
  resetWaterUserChart,
  loadCities,
  loadCityMetrics,
  setSelectedCity,
  loadTribes,
  setSelectedTribe,
  loadTribalShortages,
  loadTribeMetrics,
  loadIndustryShortages,
  listIndustryShortage,
  loadAgriculture,
  loadAgricultureMetrics,
  setSelectedAgriculture,
  loadAgricultureDistrictWater,
  listAgricultureDistrictWater,
  setWaterUserOption,
  setWaterUser,
  loadWaterDeliveries,
  listWaterDeliveries,
  resetSelectedAgriculture,
  resetSelectedCity,
  resetSelectedTribe,
  resetSelectedIndustry,
  loadCityAvailableWater,
  setScenario,
  loadIndustryMetrics,
  listIndustryMetrics,
  setSelectedIndustry,
  loadAllCitiesWaterUse,
  listAllCitiesWaterUse,
});
